export const DRAFT_COPY_STATUS = Object.freeze({
  PENDING_CLIENT: 'PENDING_CLIENT',
  CLIENT_VERIFIED: 'CLIENT_VERIFIED',
  CLIENT_REJECTED: 'CLIENT_REJECTED',
} as const);

export type DraftCopyStatus =
  (typeof DRAFT_COPY_STATUS)[keyof typeof DRAFT_COPY_STATUS];

export const DRAFT_COPY_STATUS_LABELS: Record<DraftCopyStatus, string> = {
  [DRAFT_COPY_STATUS.PENDING_CLIENT]: 'Pending review',
  [DRAFT_COPY_STATUS.CLIENT_VERIFIED]: 'Accepted',
  [DRAFT_COPY_STATUS.CLIENT_REJECTED]: 'Rejected',
};

export const DECLARATION_KIND = Object.freeze({
  UNSIGNED: 'UNSIGNED',
  SIGNED: 'SIGNED',
} as const);

export type DeclarationKind =
  (typeof DECLARATION_KIND)[keyof typeof DECLARATION_KIND];

export const TAX_FILINGS_TAB = Object.freeze({
  TAX_SUMMARY: 'tax-summary',
  DRAFT_COPIES: 'draft-copies',
  DECLARATION: 'declaration',
  FINAL_COPIES: 'final-copies',
} as const);

export type TaxFilingsTab =
  (typeof TAX_FILINGS_TAB)[keyof typeof TAX_FILINGS_TAB];

export interface TaxFilingDocument {
  id: string;
  name: string;
  type?: string;
  size: number;
  createdAt?: string;
  lastModifiedBy?: string;
  status?: DraftCopyStatus;
  rejectionComment?: string;
  kind?: DeclarationKind;
}
